module.exports = __webpack_public_path__ + "static/media/icon-button-cross-white.47c0f4a9.svg";